{
  "id": "",
  "name": "",
  "description": "",
  "workloadType": "",
  "workloadName": "",
  "assessmentType": "",
  "assessmentId": "",
  "scope": [
    {
      "accountId": "",
      "awsRegions": [
        {
          "region": "",
          "regionName": ""
        }
      ]
    }
  ],
  "assessmentTypeId": "",
  "createdAt": "",
  "updatedAt": "",
  "answered": "",
  "flagged": "",
  "unanswered": "",
  "partnerId": "",
  "productRunOn": "",
  "progressBarPercentage": 0,
  "solutionHostedOn": "",
  "status": "",
  "reportTimestamp": "",
  "staffId": ""
}
